import React from 'react';
import styles from './ReportsPage.module.css';

import { Patient } from '../../interfaces/Patient';
import { useOutletContext, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ReportsPage: React.FC = () => {

    // Hooks
    const { patient }: { patient: Patient } = useOutletContext();
    const { id } = useParams();
    const { i18n } = useTranslation();

    const hospitalCase = patient?.cases?.find(caso => caso.id === Number(id))?.hospital_case ?? '';

    const url = window.config.REPORTS_URL.replace('USER_UUID', patient.pid_1 ?? '').replace('HOSPITAL_CASE', hospitalCase) + `&len=${i18n.language.toLocaleUpperCase()}`;

    return (
        <div className={styles.container}>
            <iframe
                className={styles.iframe}
                src={url}
                title="Embedded Iframe"
            />
        </div>
    );
};

export default ReportsPage;